<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" 
	@hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" 
	title="Part Purchase Quality Control Detail">
		<template #modal-header="{ cancel }">
			<div class="w-100">
				<b-row>
					<b-col cols="12" md="9" :class="'d-flex pl-sm-0 pl-md-3 modal-title-icon'">
						<slot name="modal-header-left-button">
							<span class="mr-1 d-sm-flex d-md-none">
								<b-button size="sm" class="ml-1 btn-back " @click="cancel()" ><b-icon-arrow-left /></b-button>
							</span>
						</slot>
						<span class="icon-add">
						<img :src="publicPath + '/img/add-icon.png'" class="img-icon-add" />
						</span>
						<h5 class="modal-title"><app-long-text :maxLength="15" :mdMaxLength="50" :text="'Part Purchase Quality Control Detail'" /></h5>
					</b-col>
				<b-col cols="3">
					<span class="float-right mr-1 d-md-block d-sm-none">
						<b-button size="sm" v-if="!isExpanded" class="expand btn-link border-0 mt-1" @click="isExpanded = true">
						<b-icon-arrows-angle-expand />
						</b-button>
						<b-button size="sm" v-else class="expand btn-link border-0 mt-1" @click="isExpanded = false">
						<b-icon-arrows-angle-contract />
						</b-button>
						<b-button size="sm" class="mt-1 ml-1 btn-link btn-popup-close" @click="$bvModal.hide('modal-input')"><b-icon-x /></b-button>
					</span>
				</b-col>
				</b-row>
			</div>
		</template>
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
					<app-label label-cols-lg="12" size="sm" label="Part Description" :model="model.controlCard != null ? model.controlCard.part != null ? model.controlCard.part.partName : '' : ''" />
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" lg="6">
					<app-input-textbox id="fieldset-part-specification-qc" label-cols-lg="12" label="Part Spec" label-for="input-part-specification-qc" size="sm" :model.sync="model.partSpecificationQc" :isRequired="false" :state="validateState('partSpecificationQc')" :errorMessage="getErrorMessage(errorMessage.partSpecificationQc, 'partSpecificationQc')"/>
					<app-input-textbox id="fieldset-thickness" label-cols-lg="12" label="Thickness" label-for="input-thickness" size="sm" :model.sync="model.thickness"  type="number" />
				</b-col>
				<b-col cols="6">
					<app-input-textbox id="fieldset-width" label-cols-lg="12" label="Width" label-for="input-width" size="sm" :model.sync="model.width"  type="number" />
					<app-input-textbox id="fieldset-length" label-cols-lg="12" label="Length" label-for="input-length" size="sm" :model.sync="model.length"   type="number"/>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" lg="6">
					<b-form-group id="fieldset-karat" label-cols-lg="12" label="Karat" label-for="input-karat">
						<b-form-checkbox id="input-karat" v-model="model.karat"></b-form-checkbox>
					</b-form-group>
					<b-form-group id="fieldset-retak" label-cols-lg="12" label="Retak" label-for="input-retak" v-if="isShowInputDetail">
						<b-form-checkbox id="input-retak" v-model="model.retak"></b-form-checkbox>
					</b-form-group>
					<b-form-group id="fieldset-goresan" label-cols-lg="12" label="Goresan" label-for="input-goresan">
						<b-form-checkbox id="input-goresan" v-model="model.goresan"></b-form-checkbox>
					</b-form-group>
					<b-form-group id="fieldset-gelombang" label-cols-lg="12" label="Gelombang" label-for="input-gelombang" v-if="isShowInputDetail">
						<b-form-checkbox id="input-gelombang" v-model="model.gelombang"></b-form-checkbox>
					</b-form-group>
				</b-col>
				<b-col cols="6">
					<b-form-group id="fieldset-burry" label-cols-lg="12" label="Burry" label-for="input-burry" v-if="isShowInputDetail">
						<b-form-checkbox id="input-burry" v-model="model.burry"></b-form-checkbox>
					</b-form-group>
					<b-form-group id="fieldset-benjolan" label-cols-lg="12" label="Benjolan" label-for="input-benjolan" v-if="isShowInputDetail">
						<b-form-checkbox id="input-benjolan" v-model="model.benjolan"></b-form-checkbox>
					</b-form-group>
					<b-form-group id="fieldset-other-problem" label-cols-lg="12" label="Other Problem" label-for="input-other-problem">
						<b-form-checkbox id="input-other-problem" v-model="model.otherProblem"></b-form-checkbox>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<app-input-textarea id="fieldset-ng-information" label-cols-lg="12" label="Ng Information" label-for="input-ng-information" size="sm" :model.sync="model.ngInformation"  />
					<app-input-textbox label-cols-lg="12" label="Card Status" id="input-status" size="sm" :model.sync="model.controlCardStatusId" :isEditable="false"/>
					<app-input-textbox id="fieldset-qty" label-cols-lg="12" label="Qty" label-for="input-qty" size="sm" :model.sync="model.qty" :isEditable="false" />
				</b-col>
			</b-row>
		</b-card>

		<app-table-input-custom 
			title = "Evidence"
			:bordered="true" :items="evidenceAttachments" 
			:fields="fieldsEvidenceAttachment" 
			:busy="isDataLoading"  small responsive	
      @showPopupAddMethod="addDataEvidenceAttachment()"	
      @deleteButtonMethod="deleteRowDataEvidenceAttachment"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadEvidenceAttachment"
		>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( evidenceAttachmentPageSize * (currentEvidenceAttachmentPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(evidence)="row">
				<app-input-fileupload :id="'input-evidence-attachment-file-pendukung-' + row.index" label-cols-lg="12" label="File Pendukung" size="sm" :model.sync="filePendukungs[row.item.id]" :currentModel="row.item.evidence" @change="saveInputEvidenceAttachment(row.item)" :isEditable="true"  :nolabel="true" accept="image/*" />
			</template>
		</app-table-input-custom>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PartPurchaseQualityControlDetail from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlDetail';
import PartPurchaseQualityControlDetailFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlDetailFilter';
import toast from '@/mixins/toastMixin';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppLabel from '@/components/AppLabel';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AttachmentPartPurchaseQualityControl from '@/models/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControl';
import AttachmentPartPurchaseQualityControlFilter from '@/filters/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControlFilter';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
import AppTableInputCustom from '@/components/AppTableInputCustom';
import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo', 'isShowInput'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
		AppTableInputCustom,
		AppInputFileupload,
		AppLabel,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		controlCardId: {required},
		partSpecificationQc: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				controlCardId: { required : "ControlCard is Required."},
				thickness: { required : "Thickness is Required."},
				width: { required : "Width is Required."},
				length: { required : "Length is Required."},
				partSpecificationQc: { required : "PartSpecificationQc is Required."},
			},
			fieldsEvidenceAttachment: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"evidence": { "class" : "th-file-pendukung d-stack-none", "label" : "File Pendukung", key: 'evidence', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			controlCards : [],
			controlCardStatuss : [],
			evidenceAttachments : [], 
			sortingByEvidenceAttachment : [],
			isBusy: false,
			currentEvidenceAttachmentPage: 1,
			evidenceAttachmentPageSize: 10,
			filePendukungs: [],
			isDataLoading: false,
			isDownloadEvidenceAttachment: false,
			isExpanded: false,
		}
	},
	methods : {
		async deleteRowDataEvidenceAttachment(id,item) {
			await AttachmentPartPurchaseQualityControl.deleteData(this, id).then(result => { this.getEvidenceAttachments(); });
		},
		saveInputEvidenceAttachment(item) {
			this.isDataLoading = true;

			let id = item.id;
			let promises = Array();
			if (this.filePendukungs[id] != null) {
				this.isInputBusy = true;
				let data = new FormData();
				data.append('file', this.filePendukungs[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.evidenceId = response.data.id;
								item.evidence = response.data;
								_this.filePendukungs[id] = null;
							}
						}

						_this.isInputBusy = false;
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isInputBusy = false;
						throw error;
					}));
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					AttachmentPartPurchaseQualityControl.updateData(this, item, item.id);
				}

				this.isDataLoading = false;
			});
			this.isDataLoading = false;
		},
		getEvidenceAttachments : async function(isAddRow) {
			let filter = new AttachmentPartPurchaseQualityControlFilter();
			if (this.model.id == null) return;
			filter.partPurchaseQcDetailId = this.model.id;
			filter.draftMode = '1';
			let currentPage = (this.currentEvidenceAttachmentPage - 1);
			if (isAddRow) {
				let totalData = this.totalEvidenceAttachmentRow + 1;
				let page = Math.ceil(totalData/this.evidenceAttachmentPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.evidenceAttachmentPageSize = 0;
			// disable paging end
			AttachmentPartPurchaseQualityControl.getList(this, filter, null, currentPage , this.evidenceAttachmentPageSize).then(result => {
				this.currentEvidenceAttachmentPage = currentPage + 1;
				this.evidenceAttachments = result.data.sort((a, b) => a.id - b.id);
				this.totalEvidenceAttachmentRow = result.dataCount;
				this.filePendukungs = Array();
				for(var item of result.data) {
					this.filePendukungs[item.id] = null;
				}

			}).catch(error => {});
		},
		async addDataEvidenceAttachment() {
			AttachmentPartPurchaseQualityControl.createData(this, {partPurchaseQcDetailId: this.model.id})
			.then(result => {
				this.getEvidenceAttachments(true);
			})
		},
		getPartPurchaseQualityControlDetail : async function(id) {
			this.isBusy = true;
			PartPurchaseQualityControlDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.id = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data;
					this.model.qty = result.data[0].qtyCase;
				}
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			let model = this.model;

			if (this.$v.model.$anyError) {
				return;
			} else {
				this.getEvidenceAttachments();

				if (this.evidenceAttachments.length > 0) {
					if (this.evidenceAttachments[0].evidence == null && this.model.controlCardStatusId == 'NG') {
						return this.toast({message: 'Control Card Status NG wajib mengisi evidence', title: 'Message', variant: 'warning', autoHideDelay: 9999999});
					}
				}

				if (this.evidenceAttachments.length == 0 && this.model.controlCardStatusId == 'NG') {
					return this.toast({message: 'Control Card Status NG wajib mengisi evidence', title: 'Message', variant: 'warning', autoHideDelay: 9999999});
				}
				const msg = this.$createElement;
				let msgNode = '';
				let message = (model.controlCardStatusId == 'OK') ? '<p>Apakah MCC ini statusnya OK?</p>':'<p>Apakah MCC ini statusnya NG?</p>';
				msgNode = msg('div', { domProps: { innerHTML: message } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						let promises = Array();
						let _this = this;
							
						Promise.all(promises).then((results) => {
							_this.$emit("addButtonMethod", modalEvent, _this.model); 
						});

						this.$nextTick(() => { this.$v.$reset() })
					} else {
					return;
					}
				});
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
		scanControlCard() {
			this.focusInput(this, "fieldset-controlcard");
		},
		updateControlCardStatus() {
			if (this.model.karat || this.model.retak || this.model.goresan || this.model.gelombang || this.model.burry || this.model.benjolan || this.model.otherProblem) {
				this.model.controlCardStatusId = 'NG';
			} else {
				this.model.controlCardStatusId = 'OK';
			}
		},

	},	beforeMount() {
		//this.getControlCards();
		//this.getControlCardStatuss();
	},
	async mounted(){
	},
	beforeDestroy() {
		this.hideToast();
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartPurchaseQualityControlDetail(newValue);
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getControlCards(this.model.controlCardId);
				this.getControlCardStatuss();
				this.getEvidenceAttachments();
				this.updateControlCardStatus();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartPurchaseQualityControlDetail(this.modelId);
				}
			}
		},
		'model.karat': 'updateControlCardStatus',
		'model.retak': 'updateControlCardStatus',
		'model.goresan': 'updateControlCardStatus',
		'model.gelombang': 'updateControlCardStatus',
		'model.benjolan': 'updateControlCardStatus',
		'model.burry': 'updateControlCardStatus',
		'model.otherProblem': 'updateControlCardStatus',
		currentEvidenceAttachmentPage: {
			handler: function() {
				this.getEvidenceAttachments();
			}
		},
		evidenceAttachmentPageSize : {
			handler: function() {
				this.getEvidenceAttachments();
			}
		},
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
		isShowInputDetail : {
			get: function() {
				if (this.isShowInput == true) return true;
				return false;
			}
		}
	}
}
</script>
